import { Button } from "@mui/material";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  /* background-color: #77b2dc !important; */
  background-color: #0a32b0 !important;
  padding: 10px 50px !important;
  border-radius: 10px !important;
  background-color: ${(props) =>
    props.variant === "outlined" ? "#fff !important" : "#0a32b0 !important"};

  width: ${(props) => (props.size === "small" ? "150px !important" : "")};

  &:hover {
    /* background-color: #77b2dcd2 !important; */
    background-color: ${(props) =>
      props.variant === "outlined"
        ? "#fff !important"
        : "#0a31b0b3 !important"};
  }
  &:disabled {
    /* background-color: #c4d5dad2 !important; */
    background-color: #0a31b076 !important;
    color: "#fff" !important;
    pointer-events: auto !important ;
    cursor: not-allowed !important ;
  }
`;
